import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import {
  randFirstName,
  randLastName,
  rand,
  randChanceBoolean,
} from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'
import type { MockServer, MirageServer } from './server.js'
import { sortable, pageable, filterable } from './utils.js'
import { USER_WORK_ROLES } from '@/models/users.js'

export type CalendarUserData = SchemaAttributes<'CalendarUser'>

export const model = (Model as ModelDefinition<CalendarUserData>).extend({})

export const factory = Factory.extend<CalendarUserData>({
  first_name() {
    return randFirstName()
  },
  last_name() {
    return randLastName()
  },
  initials() {
    return (
      (this.first_name as string).charAt(0) +
      (this.last_name as string).charAt(0)
    )
  },
  avatar_initials() {
    return (
      (this.first_name as string).charAt(0) +
      (this.last_name as string).charAt(0)
    )
  },
  work_role() {
    return rand([null, ...Object.values(USER_WORK_ROLES)])
  },
  has_appointments() {
    return randChanceBoolean({ chanceTrue: 0.4 })
  },
  has_shifts() {
    return randChanceBoolean({ chanceTrue: 0.6 })
  },
})

export function routes(server: MockServer) {
  server.resource('calendarUser')

  server.get('/calendar_users', function (this: MirageServer, schema, request) {
    const users = schema.all('calendarUser')

    const sorted = sortable(users, request)

    const filtered = filterable(sorted, request, {
      search: (item, value) => {
        const firstAndLastName =
          `${item.attrs.first_name} ${item.attrs.last_name}`?.toLowerCase()
        return firstAndLastName.includes(value?.toLowerCase() || '')
      },
      start_date: () => true,
      end_date: () => true,
    })

    const { data, meta } = pageable(filtered, request)

    return {
      ...this.serialize(data),
      meta: {
        pagination: meta,
      },
    }
  })
}

export function seeds(server: MockServer) {
  server.createList('calendarUser', 25)
}
